/* eslint-disable react-hooks/exhaustive-deps */
import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addedDidYouMeanToSearchBox, setActiveFilterSearchBox, setDidYouMeanForSupportSearch } from "../../actions/searchBoxAction";
import { contextTopResultsByFirstSuggestions } from "../../controllers/contextControllers";
import { supportSearchResultListAutoSuggestions } from "../../controllers/resultListControllers";
import { searchBoxHero, searchBoxHeroCR, searchBoxHeroSuggestionsDidYouMean, searchBoxProductFinder } from "../../controllers/seachBoxControllers";
// import { supportSearchEngineCR } from "../../engine/engine";
import { isUrlShop, pillName, useDebounce } from "../../utils/utils";
import SSAutoSuggestions from "./SSAutoSuggestions";
import "./SupportSearchHero.scss";

let SupportSearchHero: FunctionComponent<any> = (props) => {
  const { controller } = props;
  const [state, setState] = useState(controller.state);

  const { resultListFirstSuggestionController } = props.suggestionController;
  const [openResultSuggestion, setOpenResultSuggestion] = useState(false);
  const [suggestionState, setSuggestionState] = useState(controller.state);
  const [stateDidYouMean, setStateDidYouMean] = useState(props.didYouMeanController.state);
  const [currentValue, setCurrentValue] = useState( '');
  const [isApplyDidYouMean, setIsApplyDidYouMean] = useState(false);
  const [isDidYouMean , setIsDidYouMean] = useState(false);
  const [isNoResult , setIsNoResult] = useState(false);
  const [suggestions , setSuggestions] = useState(false);
  const debouncedSearchTerm = useDebounce(currentValue);
  const stateDidYouMeanPrev = useSelector((state: any) => state.searchBoxReducer.stateDidYouMean);
  const isActiveFilterSearchBox = useSelector((state: any) => state.searchBoxReducer.isActiveFilterSearchBox);
  const dispatch = useDispatch();
  const [isMobileView , setIsMobileView] = useState(false);
  const [resultListByFistSuggestion , setResultListByFistSuggestion] = useState(resultListFirstSuggestionController.state.results);
  
  useEffect(() => {
    if (debouncedSearchTerm || isApplyDidYouMean) {
      updateProductFinderSuggestion(debouncedSearchTerm);
    }
  },[debouncedSearchTerm , isApplyDidYouMean]); // Only call effect if debounced search term changes

  useEffect(() => {
    if (isApplyDidYouMean) {
      setCurrentValue(stateDidYouMeanPrev);
      dispatch(addedDidYouMeanToSearchBox({ stateDidYouMean: '' }));
      dispatch(setDidYouMeanForSupportSearch({value  : ''})) ;
      setIsApplyDidYouMean(false);
    }
  }, [
    isApplyDidYouMean
  ]);
  useEffect(() => props.didYouMeanController.subscribe(() => setStateDidYouMean(props.didYouMeanController.state)), []);
  useEffect(() => props.didYouMeanController.subscribe(() => 
    {
      if(stateDidYouMean.queryCorrection.correctedQuery !== ''){
        setIsDidYouMean(true);
        dispatch(addedDidYouMeanToSearchBox({ stateDidYouMean: stateDidYouMean.queryCorrection.correctedQuery }));
        dispatch(setDidYouMeanForSupportSearch({value: stateDidYouMean.queryCorrection.correctedQuery}));
      }else{
        dispatch(setDidYouMeanForSupportSearch({ value: '' }));
      }
  
    }
  ), [stateDidYouMean.queryCorrection.correctedQuery]);
    
 
  useMemo(()=>{
    if(currentValue.length < 3){
      setOpenResultSuggestion(false);   
      dispatch(addedDidYouMeanToSearchBox({ stateDidYouMean: '' }));   
      dispatch(setDidYouMeanForSupportSearch({value  : ''})) ;
    }
  }, [currentValue])
  useEffect(() => {
    searchBoxHeroSuggestionsDidYouMean.subscribe(() => {
      setState(searchBoxHeroSuggestionsDidYouMean.state)
    });
  }, [searchBoxHeroSuggestionsDidYouMean]);

  const clearValue = () => {
    setState({
      ...state,
      value: "",
    });
    setSuggestionState({
      ...suggestionState,
      value: "",
    });
    dispatch(addedDidYouMeanToSearchBox({ stateDidYouMean: '' }));
    dispatch(setDidYouMeanForSupportSearch({value  : ''})) ;
    setCurrentValue('');
    controller.updateText("");
  };
  useEffect(() => resultListFirstSuggestionController.subscribe(() => {
      setResultListByFistSuggestion(resultListFirstSuggestionController.state.results);
  }), []);

  // useEffect(()=>{
  //   resultListFirstSuggestionController.subscribe(()=>{
  //     setResultListByFistSuggestion(resultListFirstSuggestionController.state.results)
  //   })
  // },[resultListFirstSuggestionController.state.results])

  useEffect(()=>{
    supportSearchResultListAutoSuggestions.subscribe(() => {
      if(supportSearchResultListAutoSuggestions.state.results.length === 0 && controller.state.suggestions.length > 0 && !stateDidYouMeanPrev){
        setIsNoResult(true);
        searchBoxHeroCR.selectSuggestion(controller.state.suggestions[0].rawValue)
      }else{
        setIsNoResult(false);
      }
    })
  },[supportSearchResultListAutoSuggestions.state.results])

  // Close suggestions modal when clicking out of the search input.
  document.onclick = (e: any) => {
    const searchInput =
      document.getElementsByClassName("search-hero-form-container")[0] || null;
    if (searchInput && !searchInput.contains(e.target)) {
      setOpenResultSuggestion(false);
    }
  };

  const mobilebreakpoint = 450;
  let placeHolder = "Start typing your product name (e.g. EOS 5D Mark II)";

  // Update the placeHolder text in mobile view to ignore overflow text.
  if (window.innerWidth < mobilebreakpoint) {
    placeHolder = "Start typing product name...";
  }

  const updateProductFinderSuggestion = (e: any) => {
    setState({
      ...state,
      value: e
    });
    setSuggestionState({
      ...suggestionState,
      value: "",
    });
    if (e.length > 2) {
      setIsNoResult(false);
      searchBoxHero.updateText(e);
      searchBoxHero.submit();
      setOpenResultSuggestion(true);
    } else if (openResultSuggestion) {
      setOpenResultSuggestion(false);
    }
  };

  const searchPageUrl = document.getElementById("hiddenSearchPageUrlDiv")?.getAttribute("searchPageUrl");
  const redirectResult = () => {
    if (state.value.length > 2) {
      const pageUrl: any = searchPageUrl + '?q=' + encodeURIComponent(state.value) + '&r=' + isUrlShop.SHOP;
      localStorage.setItem("pageUrl",pageUrl);
      window.location = pageUrl;
    }
  };

    useMemo(()=>{
        controller.subscribe(() => {
            setSuggestions(controller.state.suggestions);
        })
    },[])
  
  return (
    <div className="search-hero-button-form">
      <div className="search-hero-form-container support-search">
        <input
          className="search_hero_input form-control mr-sm-2"
          value={currentValue}
          placeholder={placeHolder}
          onChange={(e) => {
            setCurrentValue(e.target.value)
          }}
          onKeyDown={(e) => e.key === "Enter" && redirectResult()}
        />
        {currentValue.length > 2 && openResultSuggestion &&(
          <SSAutoSuggestions
            setIsApplyDidYouMean={setIsApplyDidYouMean}
            didYouMean={stateDidYouMeanPrev}
            controller={controller}
            // isNoResult={isNoResult}
            resultListByFirstSuggestion = {resultListByFistSuggestion}
            resultListSuggestions={supportSearchResultListAutoSuggestions.state.results}
            suggestions={suggestions}
            value={currentValue}
          />
        )}
        <button className="btn search_hero_btn">
          <div className="icon icon-search"></div>
        </button>
        {currentValue.length > 0 && (
          <div className="close-search-image-container">
            <div
              className="close-search-image"
              aria-label="Close"
              onClick={clearValue}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupportSearchHero;